<template>
    <v-form ref="form" class="w-100" v-if="item">
        <v-container fluid class="pa-0">
            <v-row class="no-frame">
                <v-col >
                    <f-title :title="$t('inb.detail.head.title')" />
                    <c-inb-context
                        :item          = "item"
                        :confirm-morph = "false"
                        :force-morph   = "true"
                        ref            = "siteselect"
                        @morph         = "onMorph"
                        @changed       = "onContext"
                    />
                </v-col>

                <v-col >
                    <f-title title="Inhalt" class="mt-0" />
                    <v-row class="no-frame">
                        <v-col class="no-frame">
                            <div>
                                <v-text-field
                                    label="Betreff"
                                    v-model = "item.subject"
                                    :rules  = "[requiredRule]"
                                />
                            </div>
                        </v-col>
                    </v-row>
                    <v-row class="no-frame">
                        <v-col class="no-frame">
                            <div>
                                <v-text-field
                                    label   = "Gemeldet von"
                                    v-model = "item.reporter"
                                    :rules  = "[requiredRule]"
                                />
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </v-form>
</template>

<script>

import CInbContext  from "@/modules/inb/components/controlls/CInbContext";
import FTitle       from "@/modules/core/components/utils/FTitle";
import Core from "@/modules/core/service/Core";
import Inb from "@/modules/inb/service/Inb";

export default {
    name: "CInboxDefault",

    props: {
        item: {

        },
        readonly: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        }
    },

    components: {
        FTitle,
        CInbContext,
    },

    data: () => ({
    }),

    computed: {
        requiredRule() {
            return Core.rule.required;
        },

        type() {
            return this.item.type;
        },
    },

    methods: {
        onSave (success) {
            this.$refs.form.validate();
            Inb.store(this, this.item).then((data) => {
                if (this.$refs.siteselect) {
                    this.$refs.siteselect.closeMenu ();
                }

                if (success) success(data)
            });
        },

        onContext (item) {
            this.$emit("context", item)
        },

        onMorph (event) {
            this.$emit("morph", event)
        },
    }
}
</script>

<style scoped>

</style>